"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndexProfilesListRequests = void 0;
const Paths_1 = require("../Paths");
const Utils_1 = require("../Utils");
const OptionsHandler_1 = require("./IndexUtils/OptionsHandler");
class IndexProfilesListRequests {
    constructor(session, appInfo) {
        this.getProfilesListByChannelName = (channelName) => this.get({ channelName });
        this.getProfilesListByUserId = (userId) => this.get({ userId });
        this.getProfilesList = () => this.get({});
        this.getProfilesListByEmail = (email) => this.get({ email });
        this.getProfilesListBySn = (sn) => this.get({ sn });
        this.get = ({ channelName, userId, email, sn, }) => __awaiter(this, void 0, void 0, function* () {
            const requestBase = {
                method: Paths_1.Methods.GET,
            };
            let endpoint = this.getRootUserEndpoint({ userId });
            if (channelName !== undefined) {
                endpoint = this.getRootChannelEndpoint({ channelName });
            }
            else if (email !== undefined) {
                endpoint = this.getRootEmailEndoint({ email });
            }
            else if (sn !== undefined) {
                endpoint = this.getRootSnEndpoint({ sn });
            }
            return this.makeRequest(endpoint, requestBase);
        });
        this.session = session;
        this.appInfo = appInfo;
        this.options = new OptionsHandler_1.OptionsHandler(this.appInfo);
    }
    makeRequest(endpoint, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = yield (0, Utils_1.buildGenericRequest)(this.session, options, this.options);
            return (0, Utils_1.wrapFetchJson)(request, endpoint);
        });
    }
    getRootChannelEndpoint({ channelName }) {
        return `${this.session.baseUrl}/${Paths_1.Constants.V1_PROFILES_LIST}/channel/${channelName}`;
    }
    getRootEmailEndoint({ email }) {
        return `${this.session.baseUrl}/${Paths_1.Constants.V1_PROFILES_LIST}/email/${email}`;
    }
    getRootUserEndpoint({ userId }) {
        return `${this.session.baseUrl}/${Paths_1.Constants.V1_PROFILES_LIST}/user${userId ? `/${userId}` : ""}`;
    }
    getRootSnEndpoint({ sn }) {
        return `${this.session.baseUrl}/${Paths_1.Constants.V1_PROFILES_LIST}/device/${sn}`;
    }
}
exports.IndexProfilesListRequests = IndexProfilesListRequests;
//# sourceMappingURL=IndexProfilesList.js.map